// // src/Components/Loader/Loader.js
// import React from "react";
// import './Loder.css';

// const Loader = () => {
//   return (
//     <div className="dot-loader-container">
//       <div className="dot-loader">
//         <span></span>
//         <span></span>
//         <span></span>
//       </div>
//     </div>
//   );
// };

// export default Loader;


// src/Components/Loader/Loader.js
import React from "react";
import './Loder.css';
import loaderImage from '../Asset/About/cro.jpg';

const Loader = () => {
  return (
    <div className="image-loader-container">
      <img src={loaderImage} alt="Loading..." className="loader-image" />
    </div>
  );
};

export default Loader;
